export default __webpack_public_path__ + "static/phone-ec865d9b0bb7c37544f3456029195178.png";